class Location {
  constructor() {
    const data = arguments[0] || {};
    this.id = data.id || null;
    this.name = data.name || "";
    this.location_id = data.location_id;
    this.events_custom_instances_id = data.events_custom_instances_id;
    this.events_custom_field_blocks_id = data.events_custom_field_blocks_id;
    this.events_custom_forms_id = data.events_custom_forms_id;
    this.events_custom_forms_products_id = data.events_custom_forms_products_id;
  }
}

export default Location;
